// src/api/clientApi.js
import config from '../config';

// ✅ Get all clients
export const getAllClients = async () => {
  const response = await fetch(`${config.apiUrl}/api/clients`);
  if (!response.ok) throw new Error('Failed to fetch clients');
  return response.json();
};

// ✅ Search client by email, mobile, or username
export const fetchClients = async (filters = {}) => {
  const query = new URLSearchParams(filters).toString();
  const response = await fetch(`${config.apiUrl}/api/clients/search?${query}`);
  if (!response.ok) throw new Error('Failed to fetch client');
  return response.json();
};

// ✅ Create a new client
export const createClient = async (clientData) => {
  const response = await fetch(`${config.apiUrl}/api/clients`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(clientData),
  });
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

// ✅ Update client
export const editClient = async (clientData) => {
  const response = await fetch(`${config.apiUrl}/api/clients/${clientData.client_id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(clientData),
  });
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

// ✅ Delete client
export const deleteClient = async (clientId) => {
  const response = await fetch(`${config.apiUrl}/api/clients/${clientId}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

// ✅ Get client by ID (if needed)
export const getClientById = async (id) => {
  const response = await fetch(`${config.apiUrl}/api/clients/${id}`);
  if (!response.ok) throw new Error('Failed to fetch client by ID');
  return response.json();
};

// ✅ Client login
export const loginClient = async (credentials) => {
  const response = await fetch(`${config.apiUrl}/api/clients/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
  });
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.message || 'Login failed');
  }
  return response.json();
};

// ✅ Logout client
export const logoutClient = async () => {
  const response = await fetch(`${config.apiUrl}/api/clients/logout`, {
    method: 'POST',
  });
  if (!response.ok) throw new Error('Failed to logout');
  return response.json();
};

// ✅ Upload profile photo
export const uploadClientProfilePhoto = async (clientId, formData) => {
  const response = await fetch(`${config.apiUrl}/api/clients/${clientId}/profile-photo`, {
    method: 'PUT',
    body: formData, // Must be FormData with key `profile_pic`
  });
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.message || 'Failed to upload photo');
  }
  return response.json();
};

// ✅ Delete profile photo
export const deleteClientProfilePhoto = async (clientId, profilePicName) => {
  const response = await fetch(`${config.apiUrl}/api/clients/${clientId}/profile-photo-delete`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ profile_pic: profilePicName }),
  });
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.message || 'Failed to delete photo');
  }
  return response.json();
};
